import React from 'react';
import { Modal, Button } from 'react-bootstrap';

interface DeleteConfirmationModalProps {
    show: boolean;
    onHide: () => void;
    onConfirm: () => void;
    title: string;
    message: string;
    warningMessage?: string;
    entityName: string;
    isDeleting: boolean;
    deleteButtonText?: string;
    cancelButtonText?: string;
}

const DeleteConfirmationModal: React.FC<DeleteConfirmationModalProps> = ({
    show,
    onHide,
    onConfirm,
    title,
    message,
    warningMessage,
    entityName,
    isDeleting,
    deleteButtonText = 'Sim, Excluir',
    cancelButtonText = 'Cancelar'
}) => {
    return (
        <Modal show={show} onHide={onHide}>
            <Modal.Header>
                <Modal.Title>{title}</Modal.Title>
            </Modal.Header>
            <Modal.Body>
                <p>
                    {message}
                </p>
                {warningMessage && (
                    <p className="text-muted">
                        {warningMessage}
                    </p>
                )}
                <p className="text-muted">
                    Esta ação não pode ser desfeita.
                </p>
            </Modal.Body>
            <Modal.Footer>
                <Button variant="secondary" onClick={onHide} disabled={isDeleting}>
                    {cancelButtonText}
                </Button>
                <Button
                    variant="danger"
                    onClick={onConfirm}
                    disabled={isDeleting}
                >
                    {isDeleting ? 'Excluindo...' : deleteButtonText}
                </Button>
            </Modal.Footer>
        </Modal>
    );
};

export default DeleteConfirmationModal; 